export const pointerDictionary = {
  openBtn: {
    en: 'Open',
    de: 'Öffnen'
  },
  prevBtn: {
    en: 'Prev',
    de: 'Zurück'
  },
  nextBtn: {
    en: 'Next',
    de: 'Weiter'
  }
}
